/* eslint-disable */
(function flexible (window, document) {
  var docEl = document.documentElement
  var dpr = window.devicePixelRatio || 1
  var maxWidth = 750

  // adjust body style
  function setBodyStyle () {
    if (document.body) {
      document.body.style.fontSize = (12 * dpr) + 'px'
      if (maxWidth) {
        document.body.style.maxWidth = maxWidth + 'px'
        document.body.style.margin = '0 auto'
      }
    }
    else {
      document.addEventListener('DOMContentLoaded', setBodyStyle)
    }
  }
  setBodyStyle();

  // set 1rem = viewWidth / 10
  function setRemUnit () {
    var rem = docEl.clientWidth / 10
    if (maxWidth && docEl.clientWidth > maxWidth) {
      rem = maxWidth / 10
    }
    docEl.style.fontSize = rem + 'px'
  }

  setRemUnit()

  // reset rem unit on page resize
  window.addEventListener('resize', setRemUnit)
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      setRemUnit()
    }
  })

  // detect 0.5px supports
  if (dpr >= 2) {
    var fakeBody = document.createElement('body')
    var testElement = document.createElement('div')
    testElement.style.border = '.5px solid transparent'
    fakeBody.appendChild(testElement)
    docEl.appendChild(fakeBody)
    if (testElement.offsetHeight === 1) {
      docEl.classList.add('hairlines')
    }
    docEl.removeChild(fakeBody)
  }
}(window, document))
